module.exports = __webpack_public_path__ + "img/manufacturing-icon.f58f2891.svg";